import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'paidTrialPlanFeaturesShown',
  'paidTrialPlanFeaturesCtaClick',
  'paidTrialPlanFeaturesDismissed',
] as const;

export const paidTrialEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
